import { useRouter } from 'next/router'
import { generateDetailUrl } from '../Listing/constants'
import classNames from 'classnames'
import { PeerComparison } from './types'

const PeerRow = ({
  peer,
  name,
  peer_rank,
  total_peers,
}: {
  peer: PeerComparison
  name?: string
  peer_rank?: number
  total_peers?: number
}) => {
  const router = useRouter()
  return (
    <div
      className={classNames('flex w-full px-1 py-4', {
        'bg-brand-tertiary-blue': peer.etf_name === name,
      })}
    >
      <div
        className={classNames('text-13px w-2/3 ', {
          'hover:text-brand-blue-azureRadiance hover:cursor-pointer':
            peer.ind_key && peer.etf_name,
        })}
        onClick={() => {
          if (peer.etf_name && peer.ind_key)
            void router.push(
              generateDetailUrl({
                stock_name: peer.etf_name,
                company_code: peer.ind_key,
              }),
            )
        }}
      >
        <div className="flex items-center gap-2">
          <div className="w-9/10 flex flex-col items-start">
            <span
              className={classNames({
                'font-medium': peer.etf_name === name,
              })}
            >
              {peer.etf_name}
            </span>
            {peer.etf_name === name &&
              typeof peer_rank === 'number' &&
              typeof total_peers === 'number' && (
                <span>
                  Rank {peer_rank} of {total_peers}
                </span>
              )}
          </div>

          {peer.etf_name && peer.ind_key && (
            <span className="w-1/10">{' >'}</span>
          )}
        </div>
      </div>
      {/* {typeof peer.expense_ratio === 'number' && (
        <div className="text-13px w-1/4 text-right">{peer.expense_ratio}</div>
      )} */}
      {typeof peer.percentage_return === 'number' && (
        <div
          className={`text-13px w-1/3 text-right ${
            peer.percentage_return < 0
              ? "text-brand-red-cinnabar before:content-['▼_']"
              : "text-brand-green-dark before:content-['▲_']"
          }`}
        >
          {peer.percentage_return}%
        </div>
      )}
    </div>
  )
}

const IndexETFComposition = ({
  peers,
  name,
  mode = 'index',
  peer_rank,
  total_peers,
}: {
  peers?: PeerComparison[]
  name?: string
  mode?: string
  peer_rank?: number
  total_peers?: number
}) => {
  if (!peers?.length) return null
  return (
    <div>
      <div className="text-brand-grey-base mt-10 flex items-center pb-2">
        <div className="text-13px w-2/3">
          {mode === 'etf' ? 'Similar ETFs' : `${name} ETFs`}
        </div>
        {/* <div className="text-13px w-1/4 text-right">Expenses</div> */}
        <div className="text-13px w-1/3 text-right">Returns</div>
      </div>
      {peers.map(peer => (
        <div key={peer.etf_name} className="flex border-t">
          <PeerRow
            peer={peer}
            name={name}
            peer_rank={peer_rank}
            total_peers={total_peers}
          />
        </div>
      ))}
    </div>
  )
}

export default IndexETFComposition
